import React, { CSSProperties, memo, ReactNode, forwardRef } from 'react';
import * as styles from './Button.module.css';

type Props = {
  children: ReactNode;
  onClick?: any;
  variant?: 'primary' | 'secondary' | 'light' | 'outline';
  icon?: string;
  iconWidth?: number;
  className?: string;
  disabled?: boolean;
  isLoading?: boolean;
  svg?: any;
  style?: CSSProperties;
};

export const Button = memo(
  forwardRef<HTMLButtonElement, Props>(
    (
      {
        className,
        disabled,
        children,
        onClick,
        variant = 'primary',
        icon,
        iconWidth = 24,
        isLoading = false,
        svg,
        style,
        ...rest
      },
      ref,
    ) => {
      return (
        <button
          ref={ref}
          disabled={disabled}
          style={style}
          className={`${
            variant === 'primary'
              ? `${styles.primary} primary-button`
              : variant === 'secondary'
                ? `${styles.secondary} secondary-button`
                : variant === 'light'
                  ? `${styles.light} light-button`
                  : variant === 'outline'
                    ? `${styles.outline} outline-button`
                    : ''
          } ${className ?? ''}`}
          onClick={onClick}
          {...rest}
        >
          {isLoading ? (
            <span className={styles.spinner}></span>
          ) : (
            <>
              {icon && (
                <img src={icon} className={styles.iconLeft} style={{ width: iconWidth }} alt="" />
              )}
              {svg && svg}
              {children}
            </>
          )}
        </button>
      );
    },
  ),
);

Button.displayName = 'Button';
